function isEmpty(val: any): boolean {
  return val == null || val === '' || (Array.isArray(val) && val.length === 0);
}

function normalizeToString(val: any): string {
  if (val == null) {
    return '';
  }

  if (Array.isArray(val)) {
    return val
      .filter((i: any) => i !== null && i !== undefined)
      .map((i: any) => {
        const label = i?.label ?? '';
        return i?.limited ? `${label} (Limited)` : label;
      })
      .filter((label: string) => label.trim() !== '')
      .join(', ')
      .trim();
  }

  return String(val).trim();
}

export function emptyValueComparator(valueA: any, valueB: any): number {
  const isEmptyA = isEmpty(valueA);
  const isEmptyB = isEmpty(valueB);

  if (isEmptyA && isEmptyB) {
    return 0;
  }
  if (isEmptyA) {
    return 1;
  }
  if (isEmptyB) {
    return -1;
  }

  if (typeof valueA === 'string' && typeof valueB === 'string') {
    const result = valueA.localeCompare(valueB);
    return result < 0 ? -1 : result > 0 ? 1 : 0;
  }

  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }

  return 0;
}

export function labelComparator(valueA: any, valueB: any): number {
  const strA = normalizeToString(valueA);
  const strB = normalizeToString(valueB);

  const isEmptyA = !strA;
  const isEmptyB = !strB;

  if (isEmptyA && isEmptyB) {
    return 0;
  }
  if (isEmptyA) {
    return 1;
  }
  if (isEmptyB) {
    return -1;
  }

  const classify = (str: string): number => {
    const firstChar = str.charAt(0);

    if (/^\d/.test(firstChar)) {
      return 2;
    }

    if (/^[a-zA-Z]/.test(firstChar)) {
      return 3;
    }
    return 1;
  };

  const classA = classify(strA);
  const classB = classify(strB);

  if (classA !== classB) {
    return classA < classB ? -1 : 1;
  }

  const removeLimit = (str: string): string =>
    str
      .replace(/\s*\(Limited\)/gi, '')
      .replace(/\s*,\s*/g, ', ')
      .trim();
  const baseA = removeLimit(strA);
  const baseB = removeLimit(strB);

  const baseComparison = baseA.localeCompare(baseB);

  if (baseComparison !== 0) {
    return baseComparison < 0 ? -1 : 1;
  }

  const hasLimitedA = strA.includes('(Limited)');
  const hasLimitedB = strB.includes('(Limited)');

  if (hasLimitedA && !hasLimitedB) {
    return 1;
  }
  if (!hasLimitedA && hasLimitedB) {
    return -1;
  }

  return 0;
}
